<template>
  <div class="header">
    <div class="header-logo" @click="toPath(0)">
      <img src="@/assets/logo&name.svg" class="logo-img" alt="" />
    </div>
    <div class="header-title my400 fs22 fc000000">
      <div
        class="item"
        :class="{ 'item-activate': isActive(0), my600: isActive(0) }"
        @click="toPath(0)">
        首页
      </div>
      <div
        class="item"
        :class="{ 'item-activate': isActive(1), my600: isActive(1) }"
        @click="toPath(1)">
        我们的产品
      </div>
      <!-- <div
        class="item"
        :class="{ 'item-activate': isActive(2), my600: isActive(2) }"
        @click="toPath(2)">
        新闻动态
      </div> -->
      <!-- <div
        class="item"
        :class="{ 'item-activate': isActive(3), my600: isActive(3) }"
        @click="toPath(3)">
        加入我们
      </div> -->
    </div>
  </div>
</template>
<script setup>
  import { useRoute, useRouter } from "vue-router";

  const route = new useRoute();
  const router = new useRouter();

  const toPath = (index) => {
    if (index == 0) {
      router.push("/");
    } else if (index == 1) {
      router.push("/product");
    } else if (index == 2) {
      router.push("/newsInformation");
    } else if (index == 3) {
      router.push("/jobDesign");
    }
  };

  const isActive = (index) => {
    const path = route.path;
    if (index === 0) return path === "/";
    if (index === 1) return path.includes("/product");
    if (index === 2) return path.includes("/newsInformation");
    if (index === 3)
      return ["/jobDesign", "/jobFunction", "/jobStudent", "/jobTechnology"].some((p) =>
        path.includes(p)
      );
    return false;
  };
</script>
<style lang="less" scoped>
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    min-width: 1200px;
    height: 100px;
    background: rgba(255, 255, 255, 0.6);
    transition: top 0.3s ease;
    box-shadow: 0px 0px 29px 0px #949494;
    overflow: hidden;
    white-space: nowrap;
    padding: 0 180px;
    box-sizing: border-box;

    .header-logo {
      cursor: pointer;
      flex-shrink: 0;

      .logo-img {
        width: 150%;
        height: 150%;
      }
    }

    .header-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 250px;
      flex-shrink: 0;

      .item {
        height: 47px;
        line-height: 47px;
        cursor: pointer;
      }

      .item-activate {
        height: 43px;
        color: #34c759;
        position: relative;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #34c759;
          border-radius: 4px;
        }
      }
      
    }
  }
</style>
